import { isTimeSignature } from '@ezchops/musicsheet';
export function isStemMedia(x) {
    return x != null &&
        (typeof x.tempo == 'number') &&
        (typeof x.url == 'string') &&
        (typeof x.duration == 'number');
}
export function isTrackStems(x) {
    return x != null && (typeof x.id == 'string') &&
        (typeof x.name == 'string') &&
        (typeof x.ownerId == 'string') &&
        (typeof x.hasMetronome == 'boolean') &&
        isTimeSignature(x.signature) &&
        (x.tempos instanceof Array) &&
        x.tempos.every((tempo) => typeof tempo == 'number') &&
        (x.stems instanceof Object) &&
        Object.values(x.stems).every((stemSet) => stemSet instanceof Array &&
            stemSet.every(isStemMedia));
}
//# sourceMappingURL=TrackStems.js.map